export default function batchSplit(arr, batchsize = 10){
  const batches = []
  for (const [index, e] of arr.entries()) {
    const batch = Math.floor(index / batchsize)
    if(!batches[batch]) batches[batch] = [e]
    else batches[batch].push(e)
  }
  return batches
}



// const logs = Array(14).fill(1).map((_e, index) => {
//   return { id: index }
// })

// batchSplit(logs)